import { render, staticRenderFns } from "./TableExpansion.vue?vue&type=template&id=4f93fd94&scoped=true&"
import script from "./TableExpansion.vue?vue&type=script&lang=js&"
export * from "./TableExpansion.vue?vue&type=script&lang=js&"
import style0 from "./TableExpansion.vue?vue&type=style&index=0&id=4f93fd94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f93fd94",
  null
  
)

export default component.exports